import { useEffect, useState } from 'react';
import { BrandstakOrder } from 'shared/types/cart/Order';
import { useAccount, useCart } from 'frontastic';

const useOrderFetch = (queryOldOrders: boolean) => {
  const { shippingMethods } = useCart();
  const { orderHistory, getOrder } = useAccount();
  const [orders, setAccountOrders] = useState<BrandstakOrder[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadingOldOrders, setLoadingOldOrders] = useState(false);
  const [error, setError] = useState(false);
  const [initialLoadCompleted, setInitialLoadCompleted] = useState(false);

  useEffect(() => {
    if (orderHistory) {
      setError(false);
      if (queryOldOrders) {
        setLoadingOldOrders(true);
      }
      orderHistory(queryOldOrders)
        .then((data) => {
          setAccountOrders((prev) => {
            // append the old orders if `queryOldOrders` is set to true
            // to avoid duplication I used Set.
            const existingIds = new Set(prev.map((order) => order.orderId));
            const newOrders = data.filter((order) => !existingIds.has(order.orderId));
            return [...prev, ...newOrders];
          });
          setLoadingOldOrders(false);
          setLoading(false);
        })
        .catch(() => {
          setAccountOrders([]);
          setLoading(false);
          setError(true);
          setLoadingOldOrders(false);
        })
        .finally(() => setInitialLoadCompleted(true));
    }
  }, [orderHistory, queryOldOrders]);

  return {
    orders,
    shippingMethods,
    loading,
    setLoading,
    error,
    initialLoadCompleted,
    getOrder,
    loadingOldOrders,
  };
};

export default useOrderFetch;
